export function StatCard({ label, value, icon: Icon, tone = "blue", testid, sub }) {
  const tones = {
    blue: "bg-blue-50 text-blue-600 dark:bg-blue-950 dark:text-blue-400",
    amber: "bg-amber-50 text-amber-600 dark:bg-amber-950 dark:text-amber-400",
    emerald: "bg-emerald-50 text-emerald-600 dark:bg-emerald-950 dark:text-emerald-400",
    rose: "bg-rose-50 text-rose-600 dark:bg-rose-950 dark:text-rose-400",
    slate: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
  };
  return (
    <div data-testid={testid} className="bg-card border rounded-xl p-4 flex items-start gap-3 hover:shadow-md transition-shadow">
      {Icon && <div className={`h-10 w-10 rounded-lg flex items-center justify-center shrink-0 ${tones[tone]}`}><Icon className="h-5 w-5" /></div>}
      <div className="min-w-0">
        <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wide truncate">{label}</div>
        <div className="font-money text-lg font-bold truncate" data-testid={`${testid}-value`}>{value}</div>
        {sub && <div className="text-xs text-muted-foreground truncate">{sub}</div>}
      </div>
    </div>
  );
}
